<template>
  <transition name="fade">
    <component v-if="error" :is="type" class="error-label text-left">
      <template v-if="isList">
        <ul>
          <li v-for="(e, index) in parsedError" :key="index">
            <span>{{ sign }}</span> {{ e }}
          </li>
        </ul>
      </template>
      <template v-else>
        <span>{{ sign }}</span> {{ parsedError }}
      </template>
    </component>
  </transition>
</template>
<script>
/**
 * ==================================================================================
 * Showing of error(s)
 * ==================================================================================
 **/
export default {
  props: {
    type: {
      type: String,
      default: 'b-form-invalid-feedback'
    },

    error: [String, Array],

    /**
     * Error symbol before the message
     */
    sign: {
      type: String,
      default: '*'
    },

    /**
     * Handles how the error will be shown
     */
    display: {
      type: String,
      default: 'sentence',
      validator: function(value) {
        return ['single', 'sentence', 'list'].indexOf(value) !== -1
      }
    }
  },

  computed: {
    /**
     * Parse the error message depending on the `display`
     * settings specified
     * @return {Array|String}
     */
    parsedError: function() {
      if (!Array.isArray(this.error)) return this.error

      switch (this.display) {
        case 'single':
          return this.error[0]
        case 'sentence':
          return this.getSentence(this.error)
        case 'list':
          return this.error.length > 1 ? this.error : this.error[0]
        default:
          return this.error
      }
    },

    /**
     * Checker if UL/LI element should be used
     * @return {Boolean}
     */
    isList: function() {
      if (this.display !== 'list') return false
      return Array.isArray(this.parsedError)
    }
  },

  methods: {
    /**
     * Join array to make a sentence with `,` and `and`
     * @return {String}
     */
    getSentence(arr) {
      if (arr.length < 2) return arr.join(' and ')
      let last = arr.pop()
      return arr.join(', ') + ' and ' + last
    }
  }
}
</script>
<style scoped lang="scss">
.error-label {
  font-family: var(--font-family);
  font-weight: 600;
  display: block;

  > ul,
  li {
    font-family: inherit;
    font-size: inherit;
  }

  > ul {
    margin: inherit;
    padding: inherit;
    color: inherit;

    li {
      list-style: none;
    }
  }
}
</style>
